import React from 'react';
import PropTypes from 'prop-types';
import config from '../../configs/appConfig';

import Dropzone from './Dropzone';
import AudioStore from '../../stores/AudioStore';

import './styles/UploadModal.scss';

export default class UploadModal extends React.Component {
  closeModal = e => {
    e && e.stopPropagation();
    this.props.closeModal();
  };

  setAudioFile = (file, blob) => {
    const audioStore = new AudioStore();
    let tempAudioEl = document && document.createElement('audio');

    tempAudioEl.addEventListener('loadedmetadata', () => {
      let duration = tempAudioEl.duration; // In seconds

      console.log(tempAudioEl.duration);

      // Either we allow any upload duration, or we must be under the max limit (in seconds)
      if (config.data.allowAnyDuration || duration <= config.data.maxDuration) {
        audioStore.createClipp(file, this.props.user);
      } else {
        alert('Audio Clipp too long!');
      }
    });

    tempAudioEl.src = URL.createObjectURL(blob);
  };

  render() {
    const { darkMode } = this.props;

    return (
      <div>
        <div className='upload-backdrop' onClick={this.closeModal} />
        <div className='upload-modal' style={{ background: darkMode ? 'rgb(11, 19, 61)' : '' }}>
          <Dropzone setAudioFile={this.setAudioFile} />
        </div>
      </div>
    );
  }
}

UploadModal.propTypes = {
  user: PropTypes.object.isRequired,
  closeModal: PropTypes.func,
  darkMode: PropTypes.bool,
};
